import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServicesComponent } from './services/services.component';
import { WhatsappConfigComponent } from './whatsapp-config/whatsapp-config.component';
import { EmailConfigComponent } from './email-config/email-config.component';
import { DBConfigComponent } from './dbconfig/dbconfig.component';
import { SchedulersComponent } from './schedulers/schedulers.component';
import { HistoryComponent } from './history/history.component';
import { AlertsServiceDetailsComponent } from './services/alerts-service-details/alerts-service-details.component';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { SmsConfigComponent } from './sms-config/sms-config.component';
import { SmsTemplateComponent } from './sms-template/sms-template.component';
import { WhatsappTemplateComponent } from './whatsapp-template/whatsapp-template.component';
import { WhatsappInboxComponent } from './whatsapp-inbox/whatsapp-inbox.component';

const routes: Routes = [
  { path: 'services', component: ServicesComponent, title: "Services" },
  { path: 'schedulers', component: SchedulersComponent, title: "Schedulers" },
  { path: 'dbcongif', component: DBConfigComponent, title: "DB Config" },
  { path: 'emailConfig', component: EmailConfigComponent, title:"Email Config" },
  { path: 'whatsappConfig', component: WhatsappConfigComponent, title: "Whatsapp Config" },
  { path: 'history', component: HistoryComponent, title: "History" },
  { path: 'services/:id', component: AlertsServiceDetailsComponent, title: "Services"},
  { path: 'email', component: EmailTemplateComponent, title: "EmailTemplate"},
  { path: 'smsconfig', component: SmsConfigComponent, title: "SmsConfigComponent"},
  { path: 'smstemplate', component: SmsTemplateComponent, title: "Sms Template"},
  { path: 'whatsapptemplate/:waConfigId', component: WhatsappTemplateComponent, title: "Whatsapp Template" },
  { path: 'whatsapptemplate', component: WhatsappTemplateComponent, title: "Whatsapp Template" },
  { path: 'whatsapp-inbox', component: WhatsappInboxComponent, title: "WhatsApp Inbox" }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationRoutingModule { }
